import {
  USER_REGISTER_LOADING,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAILURE,
} from "redux/types";

const initialState = {
  userRegisterLoading: false,
  userRegisterSuccess: null,
  errors: null,
};

export const userRegisterReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case USER_REGISTER_LOADING:
      return { ...state, userRegisterLoading: action.payload };
    case USER_REGISTER_SUCCESS:
      return { ...state, userRegisterSuccess: action.payload };
    case USER_REGISTER_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
